import { render } from "./AccessComponent.vue?vue&type=template&id=09064490&scoped=true"
import script from "./AccessComponent.vue?vue&type=script&lang=js"
export * from "./AccessComponent.vue?vue&type=script&lang=js"

import "./AccessComponent.vue?vue&type=style&index=0&id=09064490&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09064490"]])

export default __exports__